module.exports = __webpack_public_path__ + "img/ElCidPoster.1d1bfb98.jpeg";